import { Link } from "react-router-dom";

interface ResourceCardProps {
  title: string;
  link: string;
}

export default function ResourceCard({ title, link }: ResourceCardProps) {
  return (
    <Link
      to={link}
      className="block border border-gray-200 rounded-2xl p-4 hover:shadow-md transition-shadow bg-white"
    >
      <h4 className="font-semibold text-lg text-gray-800 mb-1">{title}</h4>
      <p className="text-sm text-blue-600 underline">Read more </p>
    </Link>
  );
}
